import React, { useState } from "react";
import "../../styles/components/menuSheet/menuSheet.scss";
import { userActions } from "../../store/features/user";
import { useAppDispatch } from "../../store/hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import MenuSheetWeb from "./MenuSheetWeb";
import StorageUtils from "../../backend/StorageUtils";
import MenuSheetMobile from "./MenuSheetMobile";
import Notification from "../notification/Notification";
import { switchWallet } from "../../services/verifiedBackendService/user";
import mixpanel from "mixpanel-browser";
import { OptimizedMixPanel } from "wallet-elementkit/dist/services";

function MenuSheet(props) {
	const dispatch = useAppDispatch();
	const history = useHistory();
	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);
	const [switchLoading, setSwitchLoading] = useState(false);

	const changeLang = (code) => {
		let arr = window.location.href.split("/");
		arr[3] = code;
		let adress = arr.reduce((a, b) => a + "/" + b);
		window.location.replace(adress);
	};

	const logout = () => {
		optimizedMixpanel.track("Logout");
		StorageUtils.clearExceptConfig();
		dispatch(userActions.logout());
		Notification({
			type: "success",
			text: props.translate("loggedOut"),
		});
		props.onClose();
		history.push({
			pathname: `/${props.activeLanguage ? props.activeLanguage.code : "en"}/`,
		});
	};

	const handleWalletSwitch = async (walletDomain) => {
		if (switchLoading) return;
		try {
			setSwitchLoading(true);
			let newTab = window.open("", "_blank");
			const switchData = await switchWallet();
			if (switchData && switchData.success) {
				const userId = switchData.userId;
				const verificationCode = switchData.verificationCode;
				// For Test Purposes
				// const walletDomainTest = "http://localhost:3000/";
				let url = `${walletDomain}en?isSwitch=true&userId=${userId}&verificationCode=${verificationCode}`;
				if (newTab) newTab.location.href = url;

				// OLD WAY create a tag and click it
				// var link = document.createElement("a");
				// link.href = url;
				// link.target = "_blank";
				// document.body.appendChild(link);
				// link.click();
				// document.body.removeChild(link);
			} else {
				Notification({
					type: "error",
					text: props.translate("walletSwitchError"),
				});
				if (newTab) newTab.close();
			}
			setSwitchLoading(false);
		} catch (error) {
			Notification({
				type: "error",
				text: props.translate("walletSwitchError"),
			});
			setSwitchLoading(false);
		}
	};

	if (props.isMobile) {
		return (
			<MenuSheetMobile
				sheetOpen={props.sheetOpen}
				userMeta={props.userMeta}
				onClose={props.onClose}
				handleWalletSwitch={handleWalletSwitch}
				changeLang={changeLang}
				logout={logout}
				{...props}
			/>
		);
	} else {
		return (
			<MenuSheetWeb
				sheetOpen={props.sheetOpen}
				userMeta={props.userMeta}
				onClose={props.onClose}
				handleWalletSwitch={handleWalletSwitch}
				changeLang={changeLang}
				logout={logout}
				{...props}
			/>
		);
	}
}

export default MenuSheet;
